<template>
  <div :class="['project-detail-container', permission.factoringProjectView_view?'blue-avue-form':'']">
    <div class="inner-con">
      <!-- 标题 -->
      <div class="project-title">{{basicInfoData.name}}</div>
      <!-- tab -->
      <el-tabs v-model="activeName">
        <el-tab-pane class="activelabel" label="项目详情" name="first">
          <!-- 进度图 -->
          <Steps
            :stepsConfig='stepConfig.stepsConfig'
            :stepArray="stepConfig.stepArray"
            @stepClick="stepClick"
          />
          <!-- 项目信息详情 -->
          <InfoContainer
            style="margin-top:20px;"
            :infoTitle="blockTwoConfig['infoTitle']"
            :contentConfig="blockTwoConfig['infoContent']"
          >
            <template #basicInfo>
              <avue-form
                ref="basicInfo"
                v-model="basicInfoData"
                :option="detailConfig"
              >
                <!-- 债权人和债务人选择 -->
                <template #sellerCustId>
                  <CommonSelect
                    bindLabel="custName"
                    bindKey="id"
                    bindValue="custName"
                    methods="get"
                    dataMethod="params"
                    dataUrl="bl/custbasicinformationbl/page"
                    :disabled="permission.factoringProjectView_view"
                    :bindId="basicInfoData.sellerCustId?basicInfoData.sellerCustId:''"
                    @handleChange="setSellerCustId"
                  />
                </template>
              </avue-form>
            </template>
          </InfoContainer>
          <!-- 客户走访 -->
          <InfoContainer
            style="margin-top:20px;"
            :infoTitle="blockThreeConfig['infoTitle']"
            :contentConfig="blockThreeConfig['infoContent']"
          >
            <template #basicInfo>
              <avue-crud
                :data="visitData"
                :option="visitConfig"
                :table-loading="showLoading"
              >
                <template slot="visitName" slot-scope="{ row }">
                  <div class="project-name" @click="goVisit(row)">{{row.visitName}}</div>
                </template>
              </avue-crud>
            </template>
          </InfoContainer>
          <!-- 项目额度 -->
          <InfoContainer
            v-if="basicInfoData.realReportCredit != ''"
            style="margin-top:20px;"
            :infoTitle="blockFourConfig['infoTitle']"
            :contentConfig="blockFourConfig['infoContent']"
          >
            <template #basicInfo>
              <div id="chartsContainer"></div>
            </template>
          </InfoContainer>
          <!-- 还款计划 -->
          <InfoContainer
            style="margin-top:20px;"
            :infoTitle="blockFiveConfig['infoTitle']"
            :contentConfig="blockFiveConfig['infoContent']"
          >
            <template #basicInfo>
              <avue-crud
                :data="contractData"
                :option="repaymentTableConfig"
              >
                <template slot="contractName" slot-scope="{ row }">
                  <div class="project-name" @click="goContract(row)">{{row.contractName}}</div>
                </template>
              </avue-crud>
            </template>             
          </InfoContainer>

          <!-- 支付列表 -->
          <template v-for="(item, index) in basicInfoData.contractManageList">
            <InfoContainer
              v-if="item.blContractRental.length > 0"
              :key="index"
              class="bottom-card"
              style="margin-top:20px;"
              :infoTitle="item.contractName!=''?item.contractName: ''"
              :contentConfig="blockSixConfig['infoContent']"
            >
                <template v-for="(i, s) in item.blContractRental">
                  <!-- 支付计划 -->
                  <div class="detail-one" :key="s">
                      <div class="detail-top">
                          <div class="detail-title">第{{s+1}}批还款计划</div>
                      </div>
                      <div class="detail-content">
                          <CommonDetail 
                              :configArray="paymentConfig"
                              :initValue="i"
                          >
                              <template slot="leaseTerm">
                                  <div>{{ i.planList.length }}期</div>
                                </template>
                            
                          </CommonDetail>
                      </div>

                      <el-table
                          :data="i.planList"
                          border
                          style="width: 100%; margin-top: 20px;"
                      >
                          <el-table-column
                              align="center"
                              property="issue"
                              label="期数"
                          >
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="rentDay"
                              label="还款日"
                          >
                              <template  slot-scope="scope">
                                  {{`${scope.row.rentDay.toString().slice(0,4)}年${scope.row.rentDay.toString().slice(4,6)}月${scope.row.rentDay.toString().slice(6,8)}日`}}
                              </template>
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="expectedRent"
                              label="每期保理首付款及保理首付款使用费合计额"
                          >
                            <template slot-scope="scope">
                                  {{getMoney(Number(scope.row.expectedRent))}}
                              </template>
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="principal"
                              label="每期保理首付款"
                          >
                            <template slot-scope="scope">
                                  {{getMoney(Number(scope.row.principal))}}
                              </template>
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="interest"
                              label="每期保理首付款使用费"
                          >
                              <template slot-scope="scope">
                                  {{getMoney(Number(scope.row.interest))}}
                              </template>
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="residualPrincipal"
                              label="剩余保理首付款"
                          >
                            <template slot-scope="scope">
                                  {{getMoney(Number(scope.row.residualPrincipal))}}
                              </template>
                          </el-table-column>
                          <el-table-column
                              align="center"
                              property="cashFlow"
                              label="现金流量"
                          >
                            <template slot-scope="scope">
                                  {{getMoney(Number(scope.row.cashFlow))}}
                              </template>
                          </el-table-column>

                          <el-table-column
                              align="center"
                              property="isWriteoff"
                              label="备注"
                          >
                            <template slot-scope="scope">
                               {{ scope.row.isWriteoff == 1?'已核销':scope.row.isWriteoff==0?item.prepayment.isWriteoff==1?'提前还款':'未核销':''}}
                              </template>
                          </el-table-column>
                      </el-table>
                  </div>
                </template>

            </InfoContainer>
          </template>

        </el-tab-pane>

        <el-tab-pane label="情况说明" name="second" >
          <div class="project-block" style="border: 1px solid #ccc;margin-top: 20px;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              mode="default"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="basicInfoData.projectTranslation"
              :defaultConfig="editorConfig"
              mode="default"
              @onCreated="onCreated"
            />
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="附件信息" name="third" >
          <Accessory
            idname="保理业务"
            fileMenuUrlname=""
            :projectid="id"
            :upload="true"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div
      class="bottom-container"
      v-if="!permission.factoringProjectView_view"
    >
      <div class="button-container">
        <el-button 
          type="primary"
          @click="validData"
        >保存
        </el-button>
      </div>
    </div>

    <SelectPerson
        ref="selectperson"
        :checkUserList="checkUserList"
        :isOnly="true"
        :clear="false"
        @setPeople="setPeople"
    />    
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommonDetail from "@/components/commonDetail/commonDetail"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import Accessory from "@/components/accessoriesother/accessory";
import SelectPerson from "@/components/SelectPersonnel/person";
import Steps from "@/components/steps/step";
import Highcharts from "highcharts"
import Highcharts3D from "highcharts/highcharts-3d"
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { 
  projectDetailConfig,
  stepsConfig,
  projectDetailTableConfig,
  repaymentListConfig,
  highchartsConfig,
  paymentConfig
} from './projectConfig'
import {
  addFactoringProject,
  queryFactoringProjectDetail,
  getUsedAmount,
  queryProjectDict
} from "@/api/factoring/factoring"
import { mapGetters } from "vuex";
Highcharts3D(Highcharts)
export default {
  name: 'ProjectDetail',
  data() {
    return {
      checkUserList: [],
      id: '',
      // 编辑器
      toolbarConfig: {},
      editorConfig: { placeholder: '请输入内容...' },
      editor: null,
      activeName: 'first',
      stepConfig: stepsConfig(),
      visitData: [],
      visitConfig: projectDetailTableConfig(),
      // repaymentData: [],
      contractData: [],
      paymentConfig: paymentConfig(this.getMoney),
      repaymentTableConfig: repaymentListConfig(this.getMoney),
      detailConfig: projectDetailConfig(this.selectPersonClick),
      basicInfoData: {},
      blockOneConfig: {
        infoTitle: '流程进度',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      blockTwoConfig: {
        infoTitle: '基本信息',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      blockThreeConfig: {
        infoTitle: '客户走访',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      blockFourConfig: {
        infoTitle: '项目额度',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      blockFiveConfig: {
        infoTitle: '关联合同',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      blockSixConfig: {
        infoTitle: '',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },      
      chartConfig: highchartsConfig()
    }
  },
  components: {
    Accessory,
    InfoContainer,
    CommonDetail,
    CommonSelect,
    CommentBlock,
    SelectPerson,
    Steps,
    Editor,
    Toolbar
  },
  computed: {
    ...mapGetters(["userInfo","permission"]),
  },
  async mounted() {
    this.id = this.$route.params.id
    if(this.permission.factoringProjectView_view) {
      this.detailConfig.column.map(item => {
        item.disabled = true
      })
    }
    // 查询项目详情
    this.queryProject()
  },
  beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
  },   
  methods: {
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
          return item.realName;
      });
      let ids = val.map((item) => {
          return item.id;
      });
      this.basicInfoData.assistUserName = people.join(',')
      this.basicInfoData.assistUser = ids.join(',')
    },

    goVisit(row) {
      this.$router.push({
        path: `/factoring/customerManage/customerDetail/${row.id}`,
      })
    },

    goContract(row) {
      this.$router.push({
        path: `/factoring/contractManage/contractDetail/${row.id}`,
      })
    },

    stepClick(prop, id) {
      switch(prop) {
        case 'lx':
          this.$router.push({
            path: `/factoring/buildProject/projectDetail/${id}`
          })
          break;
        case 'jd':
          this.$router.push({
            path: `/factoring/projectSurvey/surveyDetail/${id}`
          })
          break;
        case 'tz':
          this.$router.push({
            path: `/factoring/projectAdjustment/adjustmentDetail/${id}`
          })
          break;
        case 'ht':
          this.$router.push({
            path: `/factoring/contractManage/contractDetail/${id}`
          })
          break;
        case 'tf':
          this.$router.push({
            path: `/factoring/InvestmentLoanManagement/investmentLoanDetail/${id}`
          })
          break;
        case 'sw':
          this.$router.push({
                path: `/factoring/contractComplete/contractCompleteDetail/${id}`
            })
          break;  
      }
    },

    // 查询还款计划和客户走访数据
    queryTableData() {
      // let res = await queryProjectDict({id: this.id})
    },

    async queryProject() {
      let self = this
      let res = await queryFactoringProjectDetail({id: this.id})
      if(res.data.code == 200){
        this.basicInfoData = res.data.data
        // 处理数据类型
        // this.basicInfoData.sellerCustId = `${this.basicInfoData.sellerCustId}`
        this.basicInfoData.projectType = `${this.basicInfoData.projectType}`
        this.basicInfoData.projectComeFrom = `${this.basicInfoData.projectComeFrom}`
        this.basicInfoData.factoringCredit = this.basicInfoData.factoringCredit?`${Number(this.basicInfoData.factoringCredit).toFixed(2)}`:''
        // 客户走访数据
        this.visitData = this.basicInfoData.visitList
        // 合同数据
        this.contractData = this.basicInfoData.contractManageList
        this.contractData.map(item => {
          item.rentNumber = item.blContractRental.length
        })

        // 查询额度详情
        let amountRes = await getUsedAmount({id: this.id})
        let usedAmount = amountRes.data.data
        if(this.basicInfoData.realReportCredit != '') {
          this.chartConfig.series[0].data[0].name = `已用金额：${this.getMoney(Number(usedAmount))}元`
          this.chartConfig.series[0].data[0].y = Number(((Number(usedAmount)/Number(this.basicInfoData.realReportCredit))*100).toFixed(2))

          let useableAmount = Number(this.basicInfoData.realReportCredit) - Number(usedAmount)
          this.chartConfig.series[0].data[1].name = `可用金额：${this.getMoney(useableAmount)}元`
          this.chartConfig.series[0].data[1].y = Number(((Number(useableAmount)/Number(this.basicInfoData.realReportCredit))*100).toFixed(2))

          // 生成表格
          Highcharts.chart('chartsContainer', this.chartConfig);
        }

        // 处理流程进度数据
        this.stepConfig.stepsConfig.active = this.basicInfoData.currentProgress?this.basicInfoData.currentProgress: 0
        this.stepConfig.stepArray.map(item => {
          if(self.basicInfoData.progress[item.indexProp]){
            item.slot= true
            item.description = self.basicInfoData.progress[item.indexProp].time
            item.id = self.basicInfoData.progress[item.indexProp].id
            item.lastActive = item.indexProp == 'tz'?true:false
          }
        })

      }else {
        this.$message({
          type: 'warning',
          message: res.data.msg
        })
      }
    },

    validData() {
      let self = this
      if(this.basicInfoData.managerUser == this.userInfo.user_id) {
        this.$refs.basicInfo.validate((valid, done) => {
          if(valid) {
            // 校验通过, 提交数据
            self.submitForm()
            done()
          }
        })
      }else {
        this.$message.warning('您没有权限编辑保存此条数据')
      }
    },

    async submitForm() {
      let params = {
        ...this.basicInfoData
      }
      let res = await addFactoringProject(params)
      if(res.data.code == 200){
        this.$message({
          type: "success",
          message: "保存成功"
        })
        this.queryProject()
      }else {
        this.$message.error(res.data.msg);
      }
    },    

    onCreated(editor) {
      this.editor = Object.seal(editor)
    },

    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id
      this.basicInfoData.sellerCustName = data.custName
    }
  }
}
</script>
<style lang="scss" scoped>
.project-detail-container{
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .project-name{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }  
  .project-block{
    border: 1px solid #ccc;
    margin-top: 20px;    
  }
  .info-container-temp{
    /deep/.detail-one{
      padding: 0 !important;
    }
    /deep/.avue-crud__menu{
      min-height: 0 !important;
      margin-bottom: 0 !important;
    }
    /deep/.avue-crud__pagination{
      padding: 0 !important;
    }
  }
  .bottom-container{
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
    .button-container{
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }

  .inner-con{
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
      margin-top: 40px;
      margin-bottom: 40px;
    }
  }
  .detail-one{
    padding: 0px 30px !important;
    .detail-top{
      padding: 20px 5px;
      .detail-title{
        color: #666;
        font-weight: 700;
        font-size: 14px;
        line-height: 28px;
        position: relative;
        .title-tips{
          font-weight: 400;
          color: #666666;
          font-size: 13px;
        }
      }
      .detail-title::before{
        content: '';
        width: 5px;
        background-color: #409EFF;
        height: 18px;
        position: absolute;
        left: -12px;
        top: 5px;
      }
    }
  }
  .bottom-card{
    /deep/.el-card__body{
      padding-left: 40px !important;
      padding-right: 40px !important;
    }
  }
  /deep/.avue-form__menu{
    margin-bottom: 0 !important;
    height: 0 !important;
    padding: 0 !important;    
  }
  /deep/.el-tabs__item {
    font-size: 18px ;
    font-weight: bolder ;
    margin-bottom: 10px ;
  }
  /deep/.el-tabs__item.is-active {
    background: none;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
}
</style>